/**
 * WooCommerce
 *
 */
import WooCheckout from "./woocommerce/checkout";
import WooFavourite from "./woocommerce/favourite";
import MobileFilterTrigger from "./woocommerce/mobileFilterTrigger";
import Filters from "./woocommerce/filters";
import Render from "./woocommerce/render";
import AddToCart from "./woocommerce/add-to-cart";
import ProductImages from "./woocommerce/product-images";

window.addEventListener("DOMContentLoaded", () => {
	WooCheckout();
	WooFavourite();
	MobileFilterTrigger();
	new Filters(); // Init the filters
	new Render(); // Init the renderer for status and notification
	AddToCart();
	ProductImages();
});

/**
 * Non WooCommerce
 *
 */
import Accordions from "./accordions";
import Scroll from "./animations/scroll";
import Heights from "./matchHeight";
import Sliders from "./sliders";
import Filter from "./filters";
import { menuIcon } from "./menu";
import MobileMenu from "./mobileMenu";
import Tabs from "./tabs";
import Video from "./video";
import Search from "./search";

window.addEventListener("DOMContentLoaded", () => {
	Heights();
	Sliders();
	Filter();
	Video();
	Search();
	menuIcon();

	const mobileMenu = document.querySelector(".js-mobile-menu");

	if (mobileMenu) {
		new MobileMenu(mobileMenu, {
			trigger: document.querySelector(".js-menu-icon"),
			triggerClose: document.querySelector(".js-menu-icon-close"),
		});
	}

	new Scroll(
		document.querySelectorAll("[data-fade-in]"),
		{
			opacity: 0,
			top: 20,
			position: "relative",
		},
		{
			opacity: 1,
			top: 0,
			duration: 1,
		},
	);

	// Default Accordions
	const accordionSections = document.querySelectorAll("[data-accordions]");

	if (accordionSections.length) {
		accordionSections.forEach((accordions) => {
			new Accordions(accordions, "[data-accordion]", true);
		});
	}

	// Default Tabs
	const tabs = document.querySelectorAll("[data-tabs]");

	if (tabs.length) {
		tabs.forEach((tab) => {
			new Tabs(tab);
		});
	}
});
